/* eslint-disable max-lines */
/* eslint-disable complexity */
import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import DynamicListMainFields from './DynamicListMainFields'
import DynamicListTypes from './DynamicListTypes'
import GetTrendingListsPreviewService from '../../Services/Queries/getTrendingListsPreviewService'
import RenderFilterOptions from './RenderFilterOptions'
import RenderTrendingFilterOptions from './RenderTrendingFilterOptions'
import AutoSuggestionInputCrew from './castandcrew'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import getDynamicListMoviesPreviewService from '../../Services/Queries/getDynamicListMoviesPreview'
import NoOfMoviesAndLists from './NoOfMoviesAndLists'
import CreatePreview from './CreatePreview'
import CreateAndEditDynamicTable from './CreateAndEditDynamicTable'
import CrewAccordianData from './CrewAccordianData'
import { Modal, Button } from 'react-bootstrap'
import { ToastStyle } from '../Data/MovieStaticData'
import UpdateDynamicListStatusService from '../../Services/Mutations/UpdateDynamicListStatusService'

function CreateAndEditDynamiclistUi(props) {
  const {
    headerLevelPersons,
    setheaderLevelPersons,
    mode,
    listData,
    horizontalImagePresent,
    setHorizontalImage,
    configData,
    checkDisabled,
    handleCreateOrUpdateDynamicList,
    setListData,
    dynamicListInfo,
    setLoadSpinner,
    loadSpinner,
    loadPopup,
    setLoadPopup,
  } = props
  const [isButtonClicked, setIsButtonClicked] = useState(false)
  // const [loadSpinner, setLoadSpinner] = useState(false)
  const [disableUpdateButton, setDisableUpdateButton] = useState(true)
  const [ShowData, setShowData] = useState(false)
  const [limitValue, setLimitValue] = useState(10)
  const [crewconditionOrAnd] = useState('AND')
  const [castconditionOrAnd, setCastConditionOrAnd] = useState('AND')
  // const [loadPopup, setLoadPopup] = useState(false)
  const [CastData, setCastData] = useState([])

  const handleListData = (key, value) => {
    setDisableUpdateButton(false)

    if (value === 'trendingLists') {
      listData.popularListType = 'all'
      dynamicListInfo.viewsType = 'weeks'
      dynamicListInfo.popularListType = 'all'
      dynamicListInfo.viewsType = 'week'
      dynamicListInfo[key] = value
      delete dynamicListInfo.sortBy
      delete dynamicListInfo.fromDate
      delete dynamicListInfo.toDate
      delete dynamicListInfo.genre_Te
      delete dynamicListInfo.genre_En
      delete dynamicListInfo.ottPlatform
      delete dynamicListInfo.fromRating
      delete dynamicListInfo.toRating
      delete dynamicListInfo.ageRestriction
    }

    if (value === 'person') {
      listData.likesType = ''
      listData.viewsType = ''
      delete dynamicListInfo.movieID
    } else if (key === 'sortBy') {
      // listData.sortBy = value
      dynamicListInfo[key] = value
    } else if (key === 'all') {
      listData.likesType = ''
      listData.viewsType = ''
      delete dynamicListInfo.personID
      delete dynamicListInfo.movieID
    } else if (value === 'movies') {
      listData.likesType = ''
      listData.viewsType = ''
      listData.popularListType = 'movies'

      dynamicListInfo.popularListType = 'movies'

      dynamicListInfo[key] = value

      delete dynamicListInfo.personID
      delete dynamicListInfo.likesType
      delete dynamicListInfo.popularListCategory
      delete dynamicListInfo.viewsType
    } else if (value === 'date') {
      delete dynamicListInfo.viewsType
      delete dynamicListInfo.likesType
      dynamicListInfo[key] = value
    } else if (value === 'views') {
      dynamicListInfo[key] = value
      delete dynamicListInfo.likesType
    } else if (value === 'likes') {
      dynamicListInfo[key] = value
      delete dynamicListInfo.viewsType
    } else if (key === 'limit') {
      // eslint-disable-next-line use-isnan
      setLimitValue(value === NaN ? '' : parseInt(value, 10))
    } else if (key === 'castFilterBy') {
      if (CastData.length > 0) {
        dynamicListInfo.castFilterBy = value
      } else {
        delete dynamicListInfo.castFilterBy
      }

      setCastConditionOrAnd(value)
    } else if (value && key !== 'limit') {
      if (key === 'toRating' || key === 'fromRating') {
        if (value <= 5 && value >= 1) {
          const listDataTemp = { ...listData }
          listDataTemp[key] = parseInt(value, 10)
          dynamicListInfo[key] = parseInt(value, 10)
          dynamicListInfo.toRatingV2 = ''
          listDataTemp.toRatingV2 = ''
          dynamicListInfo.fromRatingV2 = ''
          listDataTemp.fromRatingV2 = ''
          setListData(listDataTemp)
        } else {
          const listDataTemp = { ...listData }
          listDataTemp[key] = ''
          dynamicListInfo[key] = ''
          dynamicListInfo.toRatingV2 = ''
          listDataTemp.toRatingV2 = ''
          dynamicListInfo.fromRatingV2 = ''
          listDataTemp.fromRatingV2 = ''
          setListData(listDataTemp)
        }
      }

      if (key === 'toRatingV2' || key === 'fromRatingV2') {
        if (value < 100) {
          const listDataTemp = { ...listData }
          listDataTemp[key] = parseInt(value, 10)
          dynamicListInfo[key] = parseInt(value, 10)
          dynamicListInfo.toRating = ''
          listDataTemp.toRating = ''
          dynamicListInfo.fromRating = ''
          listDataTemp.fromRating = ''
          setListData(listDataTemp)
        }
      }

      if (key === 'toDate' || key === 'fromDate') {
        if (key === 'fromDate') {
          if (String(listData.fromDate).includes('0000')) {
            dynamicListInfo[key] = parseInt(value, 10)
          } else {
            dynamicListInfo[key] = parseInt(value + '0000', 10)
          }
        }

        if (key === 'toDate') {
          if (String(listData.fromDate).includes('1231')) {
            dynamicListInfo[key] = parseInt(value, 10)
          } else {
            dynamicListInfo[key] = parseInt(value + '1231', 10)
          }
        }
      } else {
        dynamicListInfo[key] = value
      }
    } else {
      delete dynamicListInfo[key]
    }

    // delete dynamicListInfo.limit

    const data = { ...listData }
    if (key !== 'fromDate' || key !== 'toDate') {
      data[key] = value
    }

    if (key === 'dynamicListImage') {
      setHorizontalImage(false)
      if (value) {
        data.selectedImage = URL.createObjectURL(value)
      } else {
        data.selectedImage = ''
        delete dynamicListInfo.popularListCategory
        // delete dynamicListInfo.popularListType
        delete dynamicListInfo.likesType
      }
    }

    if (key === 'popularListType') {
      data.movieID = ''
      data.personID = ''
    }

    if (key === 'ottPlatform' && value.length === 0) {
      delete dynamicListInfo.ottPlatform
    }

    setListData(data)
  }

  const [previewData, setPreViewData] = useState([])
  const PreviewData = async () => {
    setLoadSpinner(true)

    setShowData(true)
    const removedUnWantedValues = dynamicListInfo
    delete removedUnWantedValues.__typename
    Object.keys(dynamicListInfo).forEach(key => {
      if (dynamicListInfo[key] === '') {
        delete dynamicListInfo[key]
      }
    })

    //
    let inputval
    if (listData.dynamicListID) {
      inputval = {
        limit: limitValue,
        from: 0,
        preview: true,
        dynamicListInfo,
      }
    } else {
      inputval = {
        limit: limitValue,
        from: 0,
        preview: true,
        dynamicListInfo,
      }
    }

    if (listData.dynamicListType === 'movies') {
      if (!inputval.dynamicListInfo.sortBy) {
        inputval.dynamicListInfo.sortBy = 'releaseYear'
      }

      const response = await getDynamicListMoviesPreviewService(inputval)
      setPreViewData(response && response.items ? response.items : [])
      props.setDynamicListInfo(dynamicListInfo)
    }
    // }

    if (listData.dynamicListType === 'trendingLists') {
      const response = await GetTrendingListsPreviewService(inputval)
      setPreViewData(response && response.items ? response.items : [])
      props.setDynamicListInfo(dynamicListInfo)
    }
    // }

    setLoadSpinner(false)
  }

  const ClosePopup = () => {
    setLoadPopup(false)
    setTimeout(() => {
      window.location.reload()
    }, 3000)
  }

  const approveCollection = async () => {
    setIsButtonClicked(true)
    setLoadPopup(false)
    const response = await UpdateDynamicListStatusService({
      dynamicListID: listData.dynamicListID,
      status: 'published',
    })
    if (response.statusCode === 'M022' || response.statusCode === 'M023') {
      toast.success('DynamicList Approved', ToastStyle)
      setTimeout(() => {
        window.location.reload()
      }, 6000)
    }
  }

  useEffect(() => {
    setLimitValue(listData && listData.limit ? listData.limit : '')
  }, [listData.limit])

  return (
    <div>
      <ToastContainer />
      <label>{'Dynamic Lists'}</label>
      {/* here we will have main fields like title, description, image */}
      <DynamicListMainFields
        setImageChanged={props.setImageChanged}
        setUnTagHeaderLevelPersons={props.setUnTagHeaderLevelPersons}
        setDisableUpdateButton={setDisableUpdateButton}
        dynamicListInfo={dynamicListInfo}
        headerLevelPersons={headerLevelPersons}
        setheaderLevelPersons={setheaderLevelPersons}
        editMode={mode}
        // initialHeaderPersons={initialHeaderPersons}
        listData={listData}
        handleListData={handleListData}
        horizontalImagePresent={horizontalImagePresent}
        setHorizontalImage={setHorizontalImage}
        previewData={previewData}
      />
      {/* here we will have radio buttons for filters and trending */}
      <DynamicListTypes
        dynamicListInfo={dynamicListInfo}
        listData={listData}
        handleListData={handleListData}
      />
      <NoOfMoviesAndLists
        // handlesetPopularListType={handlesetPopularListType}
        // setPopularListType={setPopularListType}
        // popularListType={popularListType}
        dynamicListInfo={dynamicListInfo}
        handleListData={handleListData}
        limitValue={limitValue}
        listData={listData}
      />
      {/* here we will have trending options */}
      {listData.dynamicListType === 'trendingLists' && (
        <RenderTrendingFilterOptions
          listData={listData}
          handleListData={handleListData}
          dynamicListInfo={dynamicListInfo}
        />
      )}
      {/* here we will have filter options */}
      {listData.dynamicListType === 'movies' && (
        <RenderFilterOptions
          setDisableUpdateButton={setDisableUpdateButton}
          listData={listData}
          configData={configData}
          mode={mode}
          dynamicListInfo={dynamicListInfo}
          handleListData={handleListData}
          setListData={setListData}
        />
      )}
      {listData.dynamicListType === 'movies' && (
        <div className='d-flex' style={{ flexDirection: 'column', gap: '10px' }}>
          <div>
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>Cast</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <select onChange={e => handleListData('castFilterBy', e.target.value)}>
                    <option></option>
                    <option selected={listData.castFilterBy === 'AND'} value='AND'>
                      AND
                    </option>
                    <option selected={listData.castFilterBy === 'OR'} value='OR'>
                      OR
                    </option>
                  </select>
                  <label>Cast:</label>
                  <AutoSuggestionInputCrew
                    setDisableUpdateButton={setDisableUpdateButton}
                    // renderedData={...listData.cast_En}
                    setCrewSelectedArryTocheckAndOrConditon={setCastData}
                    conditionOrAnd={castconditionOrAnd}
                    dynamicListInfo={dynamicListInfo}
                    typeValue={'cast_En'}
                    listData={listData}
                    setListData={setListData}
                  />
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
          <div>
            <CrewAccordianData
              setDisableUpdateButton={setDisableUpdateButton}
              handleListData={handleListData}
              listData={listData}
              crewconditionOrAnd={crewconditionOrAnd}
              dynamicListInfo={dynamicListInfo}
              setListData={setListData}
            />
          </div>
        </div>
      )}
      <CreatePreview
        disableUpdateButton={disableUpdateButton}
        checkDisabled={checkDisabled}
        handleCreateOrUpdateDynamicList={handleCreateOrUpdateDynamicList}
        mode={mode}
        PreviewData={PreviewData}
      />
      {previewData && previewData.length >= 1 && ShowData ? (
        <CreateAndEditDynamicTable previewData={previewData} />
      ) : ShowData ? (
        <p>No data found</p>
      ) : (
        ''
      )}
      {loadSpinner ? (
        <div className='loading-overlay'>
          <span className='fas fa-spinner fa-3x fa-spin'></span>
        </div>
      ) : null}
      <Modal
        show={loadPopup}
        dialogClassName='modal-90w'
        // fullscreen={'md-down'}
        onHide={() => ClosePopup()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Approve</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'Are you Sure to Approve this DynamicList'}</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => ClosePopup()}>
            Close
          </Button>
          <Button variant='primary' onClick={() => approveCollection()} disabled={isButtonClicked}>
            Approve
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default CreateAndEditDynamiclistUi
